import { render } from "./CreateWhatsNewModal.vue?vue&type=template&id=ece5ddee&scoped=true"
import script from "./CreateWhatsNewModal.vue?vue&type=script&lang=js"
export * from "./CreateWhatsNewModal.vue?vue&type=script&lang=js"

import "./CreateWhatsNewModal.vue?vue&type=style&index=0&id=ece5ddee&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece5ddee"]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QUploaderAddTrigger from 'quasar/src/components/uploader/QUploaderAddTrigger.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QUploader,QBtn,QUploaderAddTrigger,QField});
